import logo from "@/assets/jalusi-smartspaza-logo.png";

/**
 * The Jalusi SmartSpaza lockup.
 *
 * One component so the mark appears identically on the rail, the login screen
 * and anywhere else it is needed — and so replacing the artwork is one file,
 * the same bargain the colour tokens make.
 *
 * **The image carries no alt text by default**, and that is deliberate rather
 * than an omission. On the rail and the login card the product name is already
 * beside it in real text; describing the logo as well would have a screen reader
 * announce "Jalusi SmartSpaza, Jalusi SmartSpaza". Where the mark stands alone —
 * a splash, an error page — pass `label` and it becomes a proper image.
 *
 * Sized by height because the artwork is a wide lockup: constraining the width
 * on a narrow rail would shrink the wordmark to nothing.
 */
export interface LogoProps {
  /** Rendered height in pixels. The width follows the artwork's own ratio. */
  height?: number;
  /** Set only when no adjacent text names the product. */
  label?: string;
  className?: string;
}

export function Logo({ height = 32, label, className }: LogoProps) {
  return (
    <img
      src={logo}
      height={height}
      style={{ height }}
      className={className}
      alt={label ?? ""}
      aria-hidden={label ? undefined : true}
      draggable={false}
    />
  );
}
